import { createGlobalStyle } from "styled-components";

const globalStyle = createGlobalStyle`
  
`;

export default globalStyle;
